export let switchToPlainTextMenuItem = "IeoAc";
export default {switchToPlainTextMenuItem};